<script lang="ts" setup>
import OrganizationAvatar from './OrganizationAvatar.vue'
import { useActiveOrganization } from 'auth-package'
import { Sort } from '@element-plus/icons-vue'
import { useLayoutPreferencesStore } from '@/stores/layout/layoutPreferences'
import { storeToRefs } from 'pinia'

const activeOrganization = useActiveOrganization()
const layoutPreferencesStore = useLayoutPreferencesStore()
const { isOrganizationBarOpen } = storeToRefs(layoutPreferencesStore)
</script>

<template>
    <div v-if="activeOrganization" class="p-2">
        <div class="organization-bar">
            <div class="d-flex align-items-center organization-bar__inner">
                <el-button @click="layoutPreferencesStore.organizationBarToggle()" link>
                    <el-icon size="medium" style="transform: rotate(90deg)">
                        <Sort />
                    </el-icon>
                </el-button>
                <OrganizationAvatar
                    :organization="activeOrganization"
                    :showBorder="false"
                    :size="32"
                />
                <el-text
                    :style="{ minWidth: isOrganizationBarOpen ? '140px' : '192px' }"
                    tag="b"
                    truncated
                >
                    {{ activeOrganization?.name }}
                </el-text>
            </div>
        </div>
    </div>
</template>

<style lang="scss" scoped>
.organization-bar {
    padding: 6px 3px 6px 8px;
    border-radius: 12px;
    border: 1px solid var(--el-border-color-light);

    &__inner {
        gap: 12px;
    }
}
</style>
